<template>
  <div v-if="productData && Object.keys(cartProduct).length !== 0" :class="`${prefilledStylingOptions.items}  advGiftRow`">
    <div class="col-xs-12 advCartGiftItemWrapper">
      <div class="col-xs-12 advCartRow">
        <div :class="getCssColumnClasses('picker') + ' minicart-item-thumb advCartRowImg gift-row-img'"
             v-if="enablePicker || enableMinicartPicker">
          <div class="mt-checkbox-inline">
            <label class="mt-checkbox">
              <input type="checkbox"
                     value="1"
                     :checked="giftSelection"
                     @change="updateGiftSelection($event)">
              <span class="gift-select-checkbox-background"></span>
            </label>
          </div>
        </div>
        <div :class="getCssColumnClasses('icon') + ' minicart-item-thumb advCartRowImg gift-row-img'">
          <div class="thumbnail_container">
            <div class="thumbnail">
              <img :src="imageSrc" :alt="productData.productName"/>
            </div>
          </div>
        </div>
        <div :class="getCssColumnClasses('caption') + ' gift-info-row'">
          <div class="col-xs-12 m-auto gift-badge-row">
            <span class="gift-badge">
              {{ t('gift') }}
              <span v-if="cartProduct.quantity">
                  <i class="lni lni-close"></i> {{ cartProduct.quantity }}
              </span>!
            </span>
          </div>
          <div class="col-xs-12 m-auto gift-name-row">
            {{ productData.productName }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../../vue/store'
import giftSelectionMixin from './mixins/giftSelectionMixin'
import cartGiftOptionsMixin from './mixins/cartGiftOptionsMixin'

export default {
  name: 'AdvCartGiftRow',
  mixins: [giftSelectionMixin, cartGiftOptionsMixin],
  props: {
    cartProduct: {
      type: Object
    }
  },
  data () {
    return {
      version: '0.0.1'
    }
  },
  computed: {
    productData () {
      return store.getters.getProductById(this.cartProduct.productId)
    },
    imageSrc () {
      return this.productData.hasOwnProperty('productImage') ? this.productData.productImage.list : store.getters.noImage
    }
  },
  methods: {
    getCssColumnClasses (columnType) {
      const columnTypeToIdx = {
        picker: 0,
        icon: 1,
        caption: 2
      }
      const columnIdx = columnTypeToIdx[columnType]
      let columns = {
        xs: [0, 2, 10],
        lg: [0, 3, 9]
      }
      if (this.enablePicker) {
        columns = {
          xs: [1, 2, 9],
          lg: [1, 3, 8]
        }
      }
      const columnClasses = []
      for (const screen of ['lg', 'xs']) {
        const columnSize = columns[screen][columnIdx]
        columnClasses.push('col-' + ((screen === 'xs') ? 'xs' : 'lg') + '-' + columnSize)
      }
      return columnClasses.join(' ')
    }
  }
}
</script>
